module.exports = __webpack_public_path__ + "img/tupian1.7c72faa9.png";